import { NgModule } from '@angular/core';
import { SharedModule } from '../../../../shared';
import { SocioTableModule } from '../table';

import { SocioViewComponent } from './socio-view.component';

@NgModule({
    imports: [
        SharedModule,
        SocioTableModule
    ],
    declarations: [
        SocioViewComponent
    ],
    exports: [
        SocioViewComponent
    ]
})
export class SocioViewModule { }
